import React from 'react'
import clsx from 'clsx'
import './footer.scss'
import logo from '../../images/logov2.svg'
import Icon from '../../components/Icon/Icon'
import { Link } from 'gatsby'

export const Footer = ({ otherClasses }) => {
  const footerClasses = clsx(
    otherClasses,
    'w-full bg-primary_heading_color py-10 lg:pt-[120px] lg:pb-10'
  )

  const Year = new Date().getFullYear()

  return (
    <footer className={footerClasses} data-testid="footer">
      <div className="w-full max-w-[1512px] mx-auto px-6 lg:px-20 xl:px-[156px]">
        <div className="grid grid-cols-1 md:grid-cols-2 md:gap-10 lg:grid-cols-6 gap-6 lg:gap-0 mb-14 lg:mb-20">
          <div className=" md:col-span-2">
            <Link to="/">
              <img src={logo} alt="logo" className="mb-9" />
            </Link>
            <p className="font-work-sans text-sm font-bold leading-5 text-white lg:hidden  lg:pr-10 xl:pr-20">
              Royal LePage Real Estate Services Ltd. 400-231 Oak Park Blvd.
              Oakville, ON L6H 7S8
            </p>
          </div>
          <ul className="flex flex-col gap-3">
            <li className="font-work-sans text-base leading-6 font-semibold cursor-pointer text-white mb-3">
              <Link to="/about-us">Company</Link>
            </li>
            <li className="text-sm font-work-sans leading-[18px] tracking-[0.42px] py-1 capitalize text-white font-semibold cursor-pointer">
              <Link to="/about-us">about us</Link>
            </li>
            <li className="text-sm font-work-sans leading-[18px] tracking-[0.42px] py-1 capitalize text-white font-semibold cursor-pointer">
              <Link to="/about-us/testimonials">testimonials</Link>
            </li>
          </ul>
          <ul className="flex flex-col gap-3">
            <li className="font-work-sans text-base leading-6 font-semibold cursor-pointer text-white mb-3">
              <Link to="/projects">Explore</Link>
            </li>
            <li className="text-sm font-work-sans leading-[18px] tracking-[0.42px] py-1 capitalize text-white font-semibold cursor-pointer">
              <Link to="/projects">Projects</Link>
            </li>
            <li className="text-sm font-work-sans leading-[18px] tracking-[0.42px] py-1 capitalize text-white font-semibold cursor-pointer">
              <Link to="/assignments-resale">assignments</Link>
            </li>
          </ul>
          <ul className="flex flex-col gap-3">
            <li className="font-work-sans text-base leading-6 font-semibold cursor-pointer text-white mb-3">
              <Link to="/resources">Resources</Link>
            </li>
            <li className="text-sm font-work-sans leading-[18px] tracking-[0.42px] py-1 capitalize text-white font-semibold cursor-pointer">
              <Link to="/blog">Blog</Link>
            </li>
            <li className="text-sm font-work-sans leading-[18px] tracking-[0.42px] py-1 uppercase text-white font-semibold cursor-pointer">
              <Link to="/faqs">FAQs</Link>
            </li>
            <li className="text-sm font-work-sans leading-[18px] tracking-[0.42px] py-1 capitalize text-white font-semibold cursor-pointer">
              <Link to="/resources/worksheet">Reserve Your Unit</Link>
            </li>
          </ul>
          <ul className="flex flex-col gap-3">
            <li className="font-work-sans text-base leading-6 font-semibold text-white mb-3">
              Contact
            </li>
            <li className="text-sm font-work-sans leading-[18px] tracking-[0.42px] py-1 px-2  text-white font-normal">
              {/* 251 North Service Road West Oakville, ON L6M 3E7 */}
              400-231 Oak Park Blvd, Oakville ON L6H 7S8
            </li>
            <li className="text-sm font-work-sans leading-[18px] tracking-[0.42px] py-1 px-2  text-white font-normal">
              <a href="tel:6476979595">Direct: (647) 697-9595</a>
            </li>
            <li className="text-sm font-work-sans leading-[18px] tracking-[0.42px] py-1 px-2  text-white font-normal">
              <a href="tel:9052573633">Office: (905) 257-3633</a>
            </li>
            <li className="text-sm font-work-sans leading-[18px] tracking-[0.42px] py-1 px-2  text-white font-normal">
              <a href="mailto:info@allaccesshomes.ca">
                Mail: info@allaccesshomes.ca
              </a>
            </li>
          </ul>
        </div>
        <div className="flex flex-col lg:flex-row items-start lg:items-center  lg:justify-between">
          <ul className="flex flex-col lg:flex-row items-start lg:items-center gap-4 mb-10 lg:mb-0">
            <li className="font-work-sans text-sm leading-5 font-normal text-gray-200">
              &copy;{Year} All Access Homes
            </li>
            <li className="font-work-sans text-sm leading-5 font-normal text-gray-200 cursor-pointer">
              <Link to="/terms-and-conditions">Terms & Conditions</Link>
            </li>
            <li className="font-work-sans text-sm leading-5 font-normal text-gray-200 cursor-pointer">
              <Link to="/privacy-policy">Privacy Policy</Link>
            </li>
            <a
              href="https://www.wisedigitalpartners.com/nest-by-wise/"
              target="_blank"
              rel="noreferrer"
              className="font-work-sans text-sm leading-5 font-normal text-gray-200 flex items-center gap-2 cursor-pointer"
            >
              Powered by{' '}
              <Icon icon="nest-logo-icon" iconWidth={76} iconHeight={20} />
            </a>
          </ul>
          <div className="flex items-center gap-4">
            <a href="https://www.facebook.com/allaccesshomes/">
              <Icon icon="facebook-icon" iconWidth={48} iconHeight={48} />
            </a>
            <a href="https://www.instagram.com/allaccesshomes/?hl=en">
              <Icon icon="instagram-icon" iconWidth={48} iconHeight={48} />
            </a>
            <a href="https://www.linkedin.com/in/ryan-taylor-b839796">
              <Icon icon="linkedin-icon" iconWidth={48} iconHeight={48} />
            </a>
            <a href="https://www.youtube.com/@allaccesshomes">
              <Icon icon="youtube-icon" iconWidth={48} iconHeight={48} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
